export default __webpack_public_path__ + "static/media/desk3.b2cbb12a.png";